import { all } from "redux-saga/effects";
import { getHallWatcher } from "./getHall.saga";
import { getHallsListWatcher } from "./getHallsList.saga";
import {
    getSubsidiariesWatcher,
    //getCashSystemWatcher,
    getCoreVersionsWatcher,
    getTimezonesWatcher,
    getDynamicHallWatcher,
    getDynamicHallInfoWatcher
} from "./getSubsidiaries.saga";
import { getConfigurationsListWatcher } from "./getConfigurationsList.saga";
import {
    updateCreatingHallWatcher,
    updateSuggestionsWatcher
} from "./updateCreatingHall.saga";
import { createHallWatcher } from "./createHall.saga";
import {
    getServersWatcher,
    getServerWatcher,
    getServersInfoWatcher,
    getProductionServerWatcher
} from "./getServers.saga";
import { getServerLicenseWatcher } from "./getServerLicense.saga";
import { createServerWatcher, cloneServerWatcher,updateServerWatcher } from "./createServer.saga";
import { updateHallWatcher } from "./updateHall.saga";
import { deleteHallWatcher } from "./deleteHall.saga";
import { getCompareConfigurationsWatcher } from "./getCompareConfigurations.saga";
import { uploadConfigurationWatcher } from "./uploadConfiguration.saga";
import {
    initLicenseProcessWatcher,
    getServerLicenseStateWatcher,
    cancelLicenseProcessWatcher,
    rejectLicenseIdWatcher,
    confirmLicenseIdWatcher,
    updateLicenseDurationWatcher,
    getLicenseDownloadWatcher,
    setLicenseAppliedWatcher,
    renewLicenseWatcher,
    updateRemotelyLicenseWatcher,
    invalidateLicenseWatcher
} from "./licensingProcess.saga";
import { getLicenseActivityWatcher } from "./getLicenseActivity.saga";
import {
    uploadSpecificationWatcher,
    getSpecificationActivityWatcher
} from "./systemSpecification.saga";
import {
    uploadConfigurationRemotelyWatcher
} from "./uploadConfigurationRemotely.saga";

export default function* rootSaga() {
    yield all([
        getHallsListWatcher(),
        getHallWatcher(),
        getSubsidiariesWatcher(),
        getConfigurationsListWatcher(),
        updateCreatingHallWatcher(),
        createHallWatcher(),
        updateSuggestionsWatcher(),
        getServersWatcher(),
        getServerWatcher(),
        createServerWatcher(),
        cloneServerWatcher(),
        //getCashSystemWatcher(),
        getCoreVersionsWatcher(),
        updateHallWatcher(),
        deleteHallWatcher(),
        getServersInfoWatcher(),
        getProductionServerWatcher(),
        updateServerWatcher(),
        getCompareConfigurationsWatcher(),
        uploadConfigurationWatcher(),
        getTimezonesWatcher(),
        getDynamicHallWatcher(),
        getDynamicHallInfoWatcher(),

        getServerLicenseStateWatcher(),
        getServerLicenseWatcher(),
        initLicenseProcessWatcher(),
        cancelLicenseProcessWatcher(),
        rejectLicenseIdWatcher(),
        confirmLicenseIdWatcher(),
        updateLicenseDurationWatcher(),
        getLicenseDownloadWatcher(),
        setLicenseAppliedWatcher(),
        renewLicenseWatcher(),
        updateRemotelyLicenseWatcher(),
        invalidateLicenseWatcher(),
        getLicenseActivityWatcher(),

        uploadSpecificationWatcher(),
        getSpecificationActivityWatcher(),

        uploadConfigurationRemotelyWatcher()
    ]);
}
